import { useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import Slider from "react-slick";
import testimonialImg from "../../assets/images/Pull-Quote-Image-Background-1176x380.png";
import { useDynamicScripts } from "../../hooks/useDynamicScript";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { retrieveSliderPhiladelphia } from "../../redux/slice/slider-philadelphia-slice";
import { retrieveSlider } from "../../redux/slice/slider-slice";
import { RootState, useAppDispatch } from "../../redux/store";
import Europe2023Banner from "./components/europe-2023-banner";

const settings = {
  dots: false,
  infinite: true,
  arrows: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 2,
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const settingsTestimonial = {
  dots: false,
  infinite: true,
  arrows: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
};

const Europe2023Home = () => {
  const path = "europe-2023%2FHome";
  const dispatch = useAppDispatch();
  const { RapsEuropeData: pageMenuData } = useSelector((state: RootState) => state.rapsEurope);
  const { SliderData } = useSelector((state: RootState) => state.Slider);
  const { SliderPhiladelphiaData } = useSelector((state: RootState) => state.SliderPhiladelphia);

  const [pageRendered, setPageRendered] = useState(false);
    
  useEffect(() => {
    dispatch(retrievePageMenu(`%2F${path}`));
    dispatch(retrieveSlider(`%2Feurope-2023%2FHome%2FSponsors-Slider`));
    dispatch(retrieveSliderPhiladelphia(`%2Feurope-2023%2FHome%2FQuotes-Sliders`));
  }, [dispatch]);

  useEffect(() => {
    if (pageMenuData[0]?.result !== undefined) {
      setPageRendered(true);
    }
  }, [pageMenuData]);

  // Dynamic Scripts
  const [scriptHtmlString, setScriptHtmlString] = useState("");

  useEffect(() => {
    if (pageMenuData[0]?.result[0]) {
      if (pageMenuData[0]?.result[0].javaScriptField) {
        setScriptHtmlString(pageMenuData[0].result[0].javaScriptField);
      }

      if (window.runGlobalScripts) {
        window.runGlobalScripts();
      }
    }
  }, [pageMenuData]);

  useDynamicScripts({ htmlScriptString: scriptHtmlString, divId: "europe-2023-home-script" });
  // End Dynamic Scripts

  return (
    <>
      <Europe2023HomeStyleComponent />
      {/*pageRendered && cachedGoogleAdsLoader*/}
      <Helmet>
        <title>{pageMenuData[0]?.result[0]?.menuItemName}</title>
      </Helmet>
      <Europe2023Banner
        bannerImage={pageMenuData[0]?.result[0]?.mainHeaderImage}
        mobileBanner={pageMenuData[0]?.result[0]?.mobileHeaderImage}
        headerText={pageMenuData[0]?.result[0]?.headerText}
        topCommonMesage={pageMenuData[0]?.result[0]?.topCommonMesage}
      />
      <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.description }}></div>
      <div>&nbsp;</div>
      <div>&nbsp;</div>

      <div className="container hero convergence">
        <Slider className="cursor-hand" {...settingsTestimonial}>
          {SliderPhiladelphiaData[0]?.sliderItemsList?.map((item, index) => {
            return (
              <div key={index}>
                <div className="row testimonial" style={{ backgroundImage: `url(${testimonialImg})`, backgroundRepeat: "no-repeat" }}>
                  <div className="col-md-3">&nbsp;</div>
                  <div className="col-md-6 mt-4" style={{ color: "#6D6E70" }}>
                    <div>&nbsp;</div>
                    <div dangerouslySetInnerHTML={{ __html: item.sliderContents }}></div>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
      <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.councilDescription }}></div>
      <div className="container hero convergence">
        <div className="gallery">
          <Slider className="cursor-hand" {...settings}>
            {SliderData[0]?.sliderItemsList?.map((item, index) => {
              return <div key={index} dangerouslySetInnerHTML={{ __html: item.sliderContents }}></div>;
            })}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default Europe2023Home;

const Europe2023HomeStyleComponent = () => {
  return (
    <>
      <style>
        {`
      b, strong {
        font-weight: bold;
    }
    `}
      </style>
    </>
  );
};
